import { actionTypes } from '../actionTypes';
import { ILogin } from '../../model/login';

export const loginReducer = (state: ILogin[] = [], action: any) => {
  switch (action.type) {
    case actionTypes.LOGIN_SUCCESS:
      return {
        ...state,
        sessionKey: action.payload.session.session_key,
        status: true,
        ErrorStatus: false,
        ErrorMessage: "",
        logout: false,
        email: action.payload.user.email,
        user: action.payload.user.email
      }
    case actionTypes.LOGIN_FAILURE:
      return {
        ...state,
        sessionKey: '',
        status: false,
        ErrorStatus: action.error.error,
        ErrorMessage: action.error.message,
        logout: false,
        email: '',
        user: ''
      };
    case actionTypes.LOGOUT_SUCCESS:
      return {
        ...state,
        sessionKey: '',
        status: false,
        ErrorStatus: false,
        ErrorMessage: '',
        logout: true,
        email: '',
        user: ''
      };
  }

  return state;
};




// WEBPACK FOOTER //
// ./src/store/login/reducer.ts